module.exports = __webpack_public_path__ + "media/app/google-play-badge-pt-bb10f7d0.svg";